<template>
  <div class="basic w-full" style="animation-duration: 0.3s">
    <div class="bg-ec-gray-100 h-10 w-full border-b-4 border-gray-200">
      <p class="px-8 py-2 text-gray-700 font-bold">{{capitalize(action)}} Product
        <i @click="$emit('reset', 'basic')" class="el-icon-refresh-right float-right text-2xl cursor-pointer"></i>
      </p>
    </div>
    <div class="bg-ec-gray-100 mt-2 rounded px-8 pt-6 pb-8 mb-4">
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-1">
          Name
        </label>
        <el-input placeholder="e.g Granola Pack" v-model="name"></el-input>
        <p v-if="!$v.name.required" class="text-red-500 text-xs italic mt-1">Please provide a name.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-1">
          Description
        </label>
        <el-input type="textarea" v-model="description" placeholder="Some description...."></el-input>
        <p v-if="!$v.description.required" class="text-red-500 text-xs italic mt-1">Please provide a name.</p>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Detailed Description
        </label>
        <ckeditor :editor="editor" v-model="extra_description" @ready="onReady"></ckeditor>
      </div>
      <div class="group-one mb-4 flex flex-wrap justify-between">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Cost
          </label>
          <el-input placeholder="e.g 6000" v-model="cost">
            <template slot="append">
              <span v-html="'&#8358;'"></span>
            </template>
          </el-input>
          <p v-if="!$v.cost.required" class="text-red-500 text-xs italic mt-1">Cost is required</p>
          <p v-if="!$v.cost.decimal" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
          <p v-if="!$v.cost.minValue" class="text-red-500 text-xs italic mt-1">Please provide a value greater than 0</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Price
          </label>
          <el-input placeholder="e.g 6000" v-model="price">
            <template slot="append">
              <span v-html="'&#8358;'"></span>
            </template>
          </el-input>
          <p v-if="!$v.price.required" class="text-red-500 text-xs italic mt-1">Price is required</p>
          <p v-if="!$v.price.decimal" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
          <p v-if="!$v.price.minValue" class="text-red-500 text-xs italic mt-1">Please provide a value greater than 0</p>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Discount
          </label>
          <el-input placeholder="e.g 10" v-model="discount">
            <template slot="append">%</template>
          </el-input>
          <p v-if="!$v.discount.decimal" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
          <p v-if="!$v.discount.maxValue" class="text-red-500 text-xs italic mt-1">Please provide a value less than 100</p>
        </div>
      </div>
      <div class="group-one mb-4 flex flex-wrap justify-between">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Vat
          </label>
          <el-input placeholder="e.g 1 " v-model="vat">
            <template slot="append">%</template>
          </el-input>
          <p v-if="!$v.vat.required" class="text-red-500 text-xs italic mt-1">Vat is required</p>
          <p v-if="!$v.vat.decimal" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
          <p v-if="!$v.vat.between" class="text-red-500 text-xs italic mt-1">Range from 1 - 100</p>
        </div>
        <div class="w-1/3 mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Dimension
          </label>
          <input v-model="dimension" class="appearance-none border w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline" type="text" placeholder="e.g 2 X 4 X 6">
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-1">
            Weight
          </label>
          <el-input placeholder="1 (in Kg)" v-model="weight">
            <template slot="append">KG</template>
          </el-input>
          <p v-if="!$v.weight.required" class="text-red-500 text-xs italic mt-1">Weight is required</p>
          <p v-if="!$v.weight.decimal" class="text-red-500 text-xs italic mt-1">Please provide only integers</p>
        </div>
      </div>
      <div class="group-one mb-4 flex flex-wrap justify-between">
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Enable
          </label>
          <el-switch v-model="status"></el-switch>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            On Sale
          </label>
          <el-switch v-model="on_sale"></el-switch>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Shipping
          </label>
          <el-switch v-model="require_shipping"></el-switch>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Show on Home Page
          </label>
          <el-switch v-model="homepage_feature"></el-switch>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Vatable
          </label>
          <el-switch v-model="vatable"></el-switch>
        </div>
      </div>
      <div class="flex items-center justify-end">
        <el-button v-if="!edit" @click="next({page: 'catalog', step: 1})" type="primary">Next</el-button>
        <el-button v-if="edit" @click="$emit('updateBasic')" type="primary">
          <vue-loaders v-if="loading" name="line-scale-pulse-out-rapid" color="white" scale="0.5"></vue-loaders>
          <span v-if="!loading">Update</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { validationMixin } from 'vuelidate';
import CreateForm from '../../../helper/create-propduct';
import productForm from '../../../helper/form-validations';

export default {
  name: 'BasicDetails',
  mixins: [validationMixin],
  components: {
    ckeditor: CKEditor.component,
  },
  computed: {
    ...CreateForm.basic,
  },
  validations: {
    ...productForm.basic,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: 'create',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      testing: '',
      editor: DecoupledEditor,
    };
  },
  methods: {
    next(args) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('setSteps', args);
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement(),
      );
    },
  },
};
</script>

<style lang="scss">
@import "node_modules/vue2-animate/src/sass/vue2-animate.scss";
.group-one {
  div {
    flex: 0 1 24%;
  }
}

.ck.ck-editor__editable_inline{
  border: 1px gray solid !important;
  min-height: 300px !important;
}
</style>
